import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data";
import { Reveal } from "./Reveal";

export default function Services() {
  return (
    <section id="servicos" className="relative bg-white py-24 md:py-36" data-testid="services">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-6 items-end mb-14 md:mb-20">
          <Reveal className="lg:col-span-8">
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-royal font-semibold mb-5">O que fazemos</p>
            <h2 className="font-display font-extrabold text-ink tracking-tight text-4xl md:text-6xl leading-[1.02]">
              Qualquer vidro.<br />Qualquer espaço.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4">
            <p className="text-muted-foreground md:text-lg">
              Do pequeno estabelecimento ao grande complexo — trazemos o mesmo cuidado a cada superfície.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <motion.a
              key={s.id}
              href="#marcacao"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.08 }}
              className="group relative flex flex-col justify-between rounded-2xl border border-ink/10 bg-white p-8 min-h-[260px] hover:border-royal hover:shadow-[0_20px_50px_rgba(0,47,171,0.1)] transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1"
              data-testid={`service-card-${s.id}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-serif-ed italic text-3xl text-royal/60">{s.tag}</span>
                <ArrowUpRight size={22} className="text-ink/30 transition-all duration-300 group-hover:text-royal group-hover:rotate-45" />
              </div>
              <div>
                <h3 className="font-display font-bold text-2xl text-ink tracking-tight mb-3">{s.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
